var EmailItemBase = require("./EmailItemBase");
var EmailItem = xClass("EmailItem", EmailItemBase, function () {
    return cc.CSLoader.createNode("cocos/mail_mail_challenge.csb");
})

EmailItem.prototype.ctor = function () {
    var self = this;
    EmailItemBase.prototype.ctor.call(self);
    self.head = self.getChildByName("head");
    self.text = self.getChildByName("text");
}

EmailItem.prototype.initData = function (data) {
    let self = this;
    EmailItemBase.prototype.initData.call(self, data);
    self.refreshUI(data);
}

EmailItem.prototype.refreshUI = function (data) {
    let self = this;
    //
    self.head.removeAllChildren();
    //
    let newNode = cc.Node.create();
    let senderProfile = data.senderProfile;
    let title = senderProfile.nickname;
    if (title.length > 7) {
        title = title.slice(0, 7) + "...";
    }
    self.title.setString(title);
    newNode.setContentSize(self.head.width, self.head.height);
    self.head.addChild(newNode);
    DressManager.getInstance().addHeadFrameByUseShow(newNode, senderProfile.userShow, 0.8);
    HeadImageLoader.loadImage(newNode, senderProfile.avatar);
    //
    let levelId = -1;
    let extra = data.extra;
    if (extra) {
        //challengeId,challengeUid,challengeLevelId,score,isBackWin
        let arr = extra.split(",");
        self.extra = {
            levelId: Number(arr[2]),
            uid: Number(arr[1]),
            score: Number(arr[3]),
            avatar: senderProfile.avatar,
            msgId: Number(arr[0]),
        }
        levelId = self.extra.levelId;
    }
    self.text.setString(`在第${levelId}关成功战胜了你`);

    const hasDeletable = data.deletableFlag == 1;
    self.btn.setVisible(!hasDeletable);
    self.mask.setVisible(hasDeletable);
}

EmailItem.prototype.onClickAccept = function () {
    let self = this;
    if (!self.extra || !self.extra.uid) {
        self.EmailMgr.isBusy = false;
        return
    }
    if (self.data.expireTs <= Localhost.time()) {
        Toast.make(curryQuickGetErrorText(763608));
        self.EmailMgr.delMail(self.data.mailId);
        self.EmailMgr.refreshMails();
        self.EmailMgr.isBusy = false;
        return
    }
    //
    let config = self.extra;
    let otherData = {
        contestUid: config.uid, //对手uid
        formerScore: config.score, //对手分数
        issuerAvatar: config.avatar, //对手头像
        challengeLevelId: config.levelId,
        msgId: config.msgId,//消息id
        mailId: self.data.mailId,
    }
    var [logic, errCode] = require("clover/gamePlay/startEndLevelLogic/StartMainLevelLogic").create(otherData.challengeLevelId, otherData)
    if (!logic) {
        Toast.make(getText("error.tip." + tostring(errCode)));
    } else {
        logic.start(null, null, false);
        logic.startLevel();
    }
    self.EmailMgr.isBusy = false;
    //关闭消息盒子
    var homeScene = require("clover/scene/HomeScene").getInstance();
    if (homeScene.btnLayer && homeScene.btnLayer.buttonBox) {
        homeScene.btnLayer.buttonBox.close();
    }
    //
    DCAssist.dc4ShareSend("challenge", "click_beatback_icon", { "levelId": config.levelId })
    //
    self.EmailMgr.dcSimple("page_click", {
        click_type: "challenge",
        session: self.EmailMgr.dcSession,
        sub_id: self.data.mailId,
        s_time: self.EmailMgr.getDcSTime(self.data.expireTs),
    });
}

module.exports = EmailItem;
